import {useContext, useEffect, useState} from "react";
import {useIntl} from "react-intl";

import SessionPanelView, {
  SessionPanelProps as _SessionPanelProps,
  SessionPanelContainerProps
} from "./session-panel-view";
import {getClientId, getUserUIBase} from "../../api/ApiImplementation";
import {asDukeLocale} from "../localize/localize-view";
import {getAppBase} from "../../util/env";
import UIConfiguration from "../../ui-configuration/configuration-provider";
import {MenuLinkConfiguration} from "../../ui-configuration/my-licenses-configuration";

export interface SessionPanelProps extends Omit<_SessionPanelProps, keyof SessionPanelContainerProps> {}

const lougoutLinkPath =
    "/oauth20/signout?client_id=" +
    encodeURIComponent(getClientId()) +
    "&RelayState=" +
    encodeURIComponent(
        "url=" +
        window.location.href.split(getAppBase())[0] +
        getAppBase() +
        "/logout"
    );
function SessionPanel(props: SessionPanelProps) {
  const intl = useIntl();
  /* eslint-disable no-template-curly-in-string */
  const [linkBase, setLinkBase] = useState(getUserUIBase().replace(
      "${locale}",
      intl.locale !== intl.defaultLocale ? "/" + asDukeLocale(intl.locale) : ""
  ));

  const [show, onSetShow] = useState(false);
  useEffect(() => {
    setLinkBase(getUserUIBase().replace(
        "${locale}",
        intl.locale !== intl.defaultLocale ? "/" + asDukeLocale(intl.locale) : ""
    ));
  }, [intl.locale, intl.defaultLocale]);

  const { conf } = useContext(UIConfiguration);
  const [links, setLinks] = useState<MenuLinkConfiguration|undefined>(undefined);
  useEffect(() => {
    if (conf.functionality?.menu?.links) {
      const newLinks: MenuLinkConfiguration = {};
      Object.keys(conf.functionality?.menu?.links).forEach((k) => {
        newLinks[k] = conf.functionality?.menu?.links[k].replace(
            "${locale}",
            intl.locale !== intl.defaultLocale ? "/" + asDukeLocale(intl.locale) : ""
        ) as string;
      });
      setLinks(newLinks);
    } else {
      setLinks(undefined);
    }

  }, [conf.functionality?.menu?.links,intl.locale, intl.defaultLocale]);
  /* eslint-enable no-template-curly-in-string */

  return <SessionPanelView
      {...props}
      intl={intl}
      profileLink={linkBase}
      logoutLink={linkBase + lougoutLinkPath}
      show={show}
      onSetShow={onSetShow}
      links={links}
  />;
}
export default SessionPanel;
